import { PostApi } from "../pages/DashBoard/partials/Feed/types/types";
import { buildFeedPostUpdateFormData } from "./buildFeedPostUpdateFormData";
import { getParsedArray } from "./getParsedArray";

interface NewPostDataProps {
  userId: number;
  post: PostApi;
}

export const createUpdatedLikesFormData = ({ userId, post }: NewPostDataProps) => {
  const parsedLikes = getParsedArray(post.likes);

  const updatedLikes = parsedLikes.includes(userId)
    ? parsedLikes.filter((id: number) => id !== userId)
    : [...parsedLikes, userId];

  return buildFeedPostUpdateFormData(post, {
    likes: JSON.stringify(updatedLikes),
  });
};
